import { type BroadbandAppointment } from '@generated/gql/graphql';

import { type SelectedAppointment } from './types';

export const isBroadbandAppointment = (
  appointment: SelectedAppointment
): appointment is BroadbandAppointment & { suggested?: boolean } =>
  !!appointment.date && !!appointment.slot;
